/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const MeetingEventTypeDto = {
    BotJoining: 'BOT_JOINING',
    BotInCall: 'BOT_IN_CALL',
    BotRecording: 'BOT_RECORDING',
    EveryoneLeft: 'EVERYONE_LEFT',
    BotLeft: 'BOT_LEFT',
    RecordingReady: 'RECORDING_READY',
    Transcribing: 'TRANSCRIBING',
    TranscriptReady: 'TRANSCRIPT_READY',
    TranscriptFailed: 'TRANSCRIPT_FAILED',
    NoteReady: 'NOTE_READY',
    NoteEdited: 'NOTE_EDITED',
    NoteSent: 'NOTE_SENT',
    NoteDocSent: 'NOTE_DOC_SENT',
    NoteSendFailed: 'NOTE_SEND_FAILED',
    FeedbackAdded: 'FEEDBACK_ADDED',
    FeedbackEdited: 'FEEDBACK_EDITED',
    MeetingFailed: 'MEETING_FAILED'
} as const;

export type MeetingEventTypeDto = typeof MeetingEventTypeDto[keyof typeof MeetingEventTypeDto];



